import { render } from "./KeyFeatures.vue?vue&type=template&id=8ff14706&scoped=true"
import script from "./KeyFeatures.vue?vue&type=script&lang=js"
export * from "./KeyFeatures.vue?vue&type=script&lang=js"

import "./KeyFeatures.vue?vue&type=style&index=0&id=8ff14706&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ff14706"]])

export default __exports__